import Vue from 'vue'
import { router } from './router/index'
import { appRouter } from './router/router'
import panguComponentRouter from './router/panguComponentRouter'
import store from './store'
import App from './app.vue'
import util from './libs/util'
import axios from 'axios'
import { Table, TableColumn } from 'element-ui'

import commonsFunction from 'pangu-components/static/js/commonsFunction'
import commonsFunctionLocal from './libs/commonsFunction-local'
import conf from './conf'
import privateConf from './privateConf'
import SsoRequest from 'pangu-components/static/js/ssoRequest.js'

let config = Object.assign(conf, privateConf)
SsoRequest.ssoLoginUrl = config.ssoLoginUrl
SsoRequest.ticketIdKey = config.ticketIdKey

//引入全局组件
import { appMain } from 'pangu-components'
import panguComponentPlus from 'pangu-components-plus'

// let routersAll = appRouter.concat(panguComponentRouter);

axios.defaults.timeout = 60000
axios.defaults.withCredentials = true
axios.defaults.baseURL = config.baseURL

// 添加请求拦截器
axios.interceptors.request.use(
  SsoRequest.axios.interceptorsOfRequest_then,
  SsoRequest.axios.interceptorsOfRequest_catch
)
// 添加响应拦截器
axios.interceptors.response.use(
  SsoRequest.axios.interceptorsOfResponse_then,
  SsoRequest.axios.interceptorsOfResponse_catch
)

Vue.prototype.GLOBAL = config
Vue.prototype.$SsoRequest = SsoRequest
//注入axios
Vue.prototype.$axios = axios
Vue.prototype.$cfn = commonsFunction
Vue.prototype.$cfnl = commonsFunctionLocal

Vue.use(Table)
Vue.use(TableColumn)

Vue.use(appMain)
Vue.use(panguComponentPlus)

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: (h) => h(App),
  data: {
    currentPageName: '',
  },
  mounted() {
    this.currentPageName = this.$route.name
    // 显示打开的页面的列表
    // this.$store.commit('setOpenedList', this);
    this.$store.commit('initCachepage', this)
    // 权限菜单过滤相关
    // this.$store.commit('updateMenulist');
    // iview-admin检查更新
    util.checkUpdate(this)
  },
  filters: {
    trim: function (value) {
      return value.trim()
    },
  },
  methods: {
    logout() {
      this.$axios
        .get('/rest/main/index/logout')
        .then((res) => {
          if (res.data.code === 200) {
            store.commit('logout', this)
            store.commit('clearOpenedSubmenu')
            console.info(111, this.$SsoRequest)
            this.$SsoRequest.gotoSSOLogin(this)
          }
        })
        .catch((res) => {
          that.$cfn.ajax1.catch1(res, this)
        })
      // store.commit('logout', this);
      // store.commit('clearOpenedSubmenu');
      // sessionStorage.clear();
      // this.$router.push({
      //   name: 'login'
      // });
    },
  },
  // created() {
  //     let tagsList = [];
  //     routersAll.map((item) => {
  //         if (item.children&&item.children.length <= 1) {
  //             tagsList.push(item.children[0]);
  //         } else {
  //             tagsList.push(...item.children);
  //         }
  //     });
  //     this.$store.commit('setTagsList', tagsList);
  // }
})
